import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import Loading from "../../../components/Loading";
import ProgramNameCard from "../../../components/program/ProgramNameCard";
import { gql } from "@urql/core";
import { useQuery } from "urql";
import { client } from "../../../graphql/client";
import { cssAppliedContent } from "../../../utils/cssAppliedContent";

const query = gql`
  query MyQuery($name: [String!]!) {
    class_headers(
      order_by: { program: { id: asc } }
      where: {
        deleted_at: { _is_null: true }
        program: { name: { _in: $name } }
      }
    ) {
      name
      description
      cover
      category
      class_registrations {
        end_date
      }
      program {
        name
      }
    }
  }
`;

const getQuery = async (url) => {
  const query = gql`
    query MyQuery(
      $limit: Int
      $offset: Int
      $url: String
      $order: [cms_promotions_order_by!]
    ) {
      cms_promotions(
        limit: $limit
        offset: $offset
        order_by: $order
        where: { deleted_at: { _is_null: true }, url: { _eq: $url } }
      ) {
        link
        id
        url
        program
        title
        description
        created_at
      }
    }
  `;

  const { data } = await client.query(query, { url: url }).toPromise();
  return data;
};

export async function getServerSideProps(context) {
  const { params } = context;
  const { url } = params;

  const data = await getQuery(url);

  return { props: { data: data || null } };
}

export default function url({ data }) {
  const {
    query: { url },
  } = useRouter();
  const promoData = data?.cms_promotions[0];
  const program = promoData?.program?.split(";")
    ? promoData?.program?.split(";")
    : [];
  const [dataProgram, setDataProgram] = useState([]);
  const [{ data: tmpData, fetching, error }] = useQuery({
    query: query,
    variables: {
      name: program,
    },
  });

  useEffect(() => {
    if (tmpData) {
      const arr = [];
      for (const item of tmpData.class_headers) {
        const body = {
          name: item.name,
          link: item.name,
          description: item.description,
          cover: item.cover !== null ? item.cover : "/images/artikel8.webp",
          category: item.category,
          program: item.program.name,
        };
        arr.push(body);
      }
      setDataProgram(arr);
    }
  }, [tmpData, url]);

  const schemeData = {
    "@type": "E-Brocure",
    data: data,
  };

  return (
    <main className="h-full w-full bg-[#F3F7FA]">
      <Head>
        <title>
          Promosi {promoData?.title} | Wardaya Online by Wardaya College
        </title>
        <meta name="description" content={`${promoData?.description}`} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemeData),
          }}
        />
      </Head>

      <div className="mx-auto flex w-full max-w-[1260px] flex-col items-center px-4 pt-24 md:pt-36">
        <div className="flex w-full flex-col items-center justify-center gap-3 pb-10">
          <iframe
            // src={`${promoData?.link}`}
            src={`${promoData?.link}&autoplay=1`}
            title="YouTube video player"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="h-full w-full p-2.5 lg:h-[630px] lg:w-[1120px]"
          />
          <div className="flex w-full items-start">
            <div
              className="prose !max-w-full"
              dangerouslySetInnerHTML={{
                __html: cssAppliedContent(promoData?.description),
              }}
            ></div>
          </div>
        </div>

        <h1 className="bg-gradient-to-tr from-[#024D88] to-[#006ABE] bg-clip-text font-nunito text-2xl font-black capitalize text-transparent md:text-4xl">
          {promoData?.title}
        </h1>

        <div className="mx-auto flex max-w-[1280px] flex-col px-3">
          <div className="mt-12 w-full pb-24">
            <ul className="grid grid-cols-2 gap-2 md:gap-5 lg:grid-cols-4">
              {dataProgram.map((item, key) => (
                <ProgramNameCard
                  key={key}
                  name={item.name}
                  description={item.description}
                  cover={item.cover ? item.cover : "/images/logo.png"}
                  link={item.link}
                  slug={item.program}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>

      {fetching ? (
        <div className="fixed top-0 left-0 z-[150] flex h-screen w-screen items-center justify-center bg-black bg-opacity-10">
          <Loading fillcolor={"#EA374C"} />
        </div>
      ) : null}
      <style jsx>
        {`
          #table {
            overflow: scroll;
          }
        `}
      </style>
    </main>
  );
}
